import { render, staticRenderFns } from "./SuppliersUploadInvoice.vue?vue&type=template&id=15009bdd&"
import script from "./SuppliersUploadInvoice.vue?vue&type=script&lang=ts&"
export * from "./SuppliersUploadInvoice.vue?vue&type=script&lang=ts&"
import style0 from "./SuppliersUploadInvoice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VContainer,VImg})
